import qr from "../../icons/qr.png";
import BuscadorMercaderias from "../../ComponentesGlobales/BuscadorMercaderias";
import { useStoreDespachos } from "./useStoreDespachos";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useState, useMemo } from "react";
import { useStoreHome } from "../Home/useStoreHome";
import { MensajeInfo, MensajeToastAdvertencia, MensajeToastError } from "../../componentes/FuncionesLocales";
import ScannerUnico from "../../ComponentesGlobales/ScannerUnico";

const DespachoTab2 = () => {

    const Mercaderia = useStoreDespachos((state) => state.Mercaderia);
    const Unidades = useStoreDespachos((state) => state.Unidades);
    const Kilos = useStoreDespachos((state) => state.Kilos);
    const ListaMercaderias = useStoreDespachos((state) => state.ListaMercaderias);
    const Numero = useStoreDespachos((state) => state.Numero);
    const Cliente = useStoreDespachos((state) => state.Cliente);
    const [showQRScanner, setShowQRScanner] = useState(false);
    const deviceConsentimiento = useStoreHome((state) => state.deviceConsentimiento);
    const CodbarItem = useStoreDespachos((state) => state.CodbarItem);
    const BuscandoCodbarItem = useStoreDespachos((state) => state.BuscandoCodbarItem);
    const MercaderiaUnidad = useStoreDespachos((state) => state.MercaderiaUnidad);

    const Guardar = () => {
        if (String(Numero).trim() === "") {
            MensajeInfo("Debe cargar el numero del Cliente");
            return;
        }
        if (Number(Numero) <= 0 || String(Numero).trim() === "") {
            MensajeInfo("El número del Cliente debe ser mayor a 0.");
            return;
        }
        if (!Cliente || String(Cliente) === "") {
            MensajeInfo("Debe seleccionar un cliente.");
            return;
        }

        if (!Mercaderia || !Mercaderia.Id || !Mercaderia.Id === 0) {
            MensajeInfo("Debe seleccionar una mercadería.");
            return;
        }
        if (Number(Unidades) <= 0 && Number(Kilos) <= 0) {
            MensajeInfo("El valor debe ser mayor a 0.");
            return;
        }
        useStoreDespachos.getState().insert();
    };


    useEffect(() => {
        if (CodbarItem) {
            useStoreDespachos.setState({ Mercaderia: CodbarItem.Mercaderia });
            useStoreDespachos.setState({ Unidades: Number(CodbarItem.nUnidades) });
            useStoreDespachos.setState({ Kilos: Number(CodbarItem.nPeso) });
        }
        else {
            useStoreDespachos.setState({ Mercaderia: null });
            useStoreDespachos.setState({ Unidades: 1 });
            useStoreDespachos.setState({ Kilos: 0 });
        }
    }, [CodbarItem]);

    const [Entrolectura, setEntroLectura] = useState(false);
    const [lastQrValue, setLastQrValue] = useState('');

    const openQRScanner = () => {
        if (deviceConsentimiento !== "granted") {
            MensajeToastAdvertencia("Habilitá permisos en el Home para usar la cámara.", 3000);
            return;
        }
        if (!window.isSecureContext) {
            MensajeToastAdvertencia("La cámara funciona solo en https o localhost (no en 192.168.x.x http).", 4000);
            return;
        }
        if (!navigator.mediaDevices?.getUserMedia) {
            MensajeToastAdvertencia("Tu navegador no soporta acceso a cámara.", 3000);
            return;
        }
        setShowQRScanner(true);
    };


    const closeQRScanner = () => {
        console.log('🚪 Cerrando QR Scanner desde EntradasTab1...');
        setShowQRScanner(false);

        // Limpieza adicional de seguridad para cualquier video elemento que pueda quedar
        setTimeout(() => {
            try {
                const videos = Array.from(document.querySelectorAll("video"));
                videos.forEach((video) => {
                    const stream = video.srcObject;
                    if (stream?.getTracks) {
                        const tracks = stream.getTracks();
                        tracks.forEach(track => {
                            if (track.readyState === 'live') {
                                track.stop();
                            }
                        });
                    }
                    // Limpiar el video element
                    video.srcObject = null;
                    video.src = '';
                });
            } catch (error) {
                console.warn("No se pudo completar la limpieza de la cámara:", error);
            }
        }, 100); // Pequeño delay para asegurar que el componente se desmonte primero
    };

    const handleQRScan = (result) => {
        // Verificaciones para evitar doble escaneo
        if (Entrolectura) {
            console.log('🚫 Escaneo bloqueado: procesando lectura anterior');
            return;
        }

        // Evitar el mismo código QR en un corto período de tiempo
        if (lastQrValue === result) {
            console.log('🚫 Escaneo bloqueado: mismo código QR reciente');
            return;
        }

        setEntroLectura(true);
        setLastQrValue(result);

        try {
            useStoreDespachos.setState({ CodbarLeido: { sCodbar: result } });
            setShowQRScanner(false);
            useStoreDespachos.getState().getCodbar(result)

        } catch (error) {
            MensajeToastError("Ocurrió un error al procesar el código QR: " + error.message, 5000);
        } finally {
              // Permitir nuevo escaneo después de un retraso más largo
            setTimeout(() => {
                setEntroLectura(false);
                // console.log('✅ Listo para nuevo escaneo');
            }, 1500);

            // Limpiar el último QR después de un tiempo para permitir re-escaneo del mismo código
            setTimeout(() => {
                setLastQrValue('');
                // console.log('🔄 Cache de QR limpiado');
            }, 5000);
        }
    };

    useEffect(() => {
        if (Mercaderia && Mercaderia.Id) {
            useStoreDespachos.getState().getMercaderiaUnidad();
        }
    }, [Mercaderia]);

    const mercaderiaSel = useMemo(
        () => ListaMercaderias?.find(x => x.Id === Mercaderia?.Id),
        [ListaMercaderias, Mercaderia]
    );

    const stockKg = Mercaderia?.sExtra ?? mercaderiaSel?.sExtra ?? 0;


    return (
        <>
            <div className="desp-bloque-form">
                <h4 className="ing-subtitulo">Productos</h4>
                <div className="desp-fila-flex">


                    <BlockUI blocked={BuscandoCodbarItem}
                        template={<ProgressSpinner style={{ width: '24px', height: '24px', color: "white" }} strokeWidth="8" animationDuration="5.15s" />} >

                        <div className="desp-campo-qr">
                            <input
                                type="text"
                                readOnly={true}
                                placeholder={CodbarItem?.sCodbar || "Escanear QR"}
                                value={CodbarItem ? CodbarItem.sCodbar : ""}
                                className="input-qr"
                            />
                            <img
                                src={qr}
                                alt="qr"
                                className="qr clickable"
                                onClick={deviceConsentimiento === "granted" ? openQRScanner : undefined}
                                title={deviceConsentimiento === "granted" ? "Abrir escáner QR" : "Necesita permiso en Home"}
                                style={{ cursor: deviceConsentimiento === "granted" ? "pointer" : "not-allowed", opacity: deviceConsentimiento === "granted" ? 1 : 0.4 }}
                            />
                        </div>
                        {CodbarItem?.sCodbar && <h5 style={{ marginBottom: '8px', color: 'red', fontSize: '10px', alignSelf: 'center', width: '100%' }}>Se ingresara este codigo Id: {CodbarItem.IndentificadorId}</h5>}
                    </BlockUI>

                    <div className="desp-campo">
                        <div className="camp-o">
                            <label>Nombre Producto:</label>
                        </div>
                        <BuscadorMercaderias
                            Buscar={useStoreDespachos.getState().getMercaderia}
                            LimpiarResultados={useStoreDespachos.getState().limpiarResultadosMercaderias}
                            setValor={(e) => useStoreDespachos.setState({ Mercaderia: e })}
                            Seleccionado={Mercaderia} TituloNoSeleccionado={"Seleccione un producto con stock"} />
                    </div>

                    <div className="desp-campo">
                        <div className="camp-o">
                            {Number(Kilos) === 0 && (
                                <span className="mensaje-obligatorio">*</span>
                            )}
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <label>{MercaderiaUnidad?.sDescripcion || "Medida"}</label>
                                <label style={{ marginRight: '8px' }}>Stock: {Number(stockKg)}</label>
                            </div>
                        </div>
                        <input
                            type="number"
                            name="kilos"
                            value={Kilos}
                            onChange={(e) => useStoreDespachos.setState({ Kilos: e.target.value })}
                            placeholder="0000"
                            required
                        />
                    </div>
                    <span className="mensaje-obligatorio">* Campo obligatorio</span>
                </div>
                <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                    <button onClick={Guardar} type="submit" style={{ background: "var(--app-brand)", color: "#fff" }}>Agregar</button>
                </div>
            </div>


            {showQRScanner && (
                <ScannerUnico
                    isActive={showQRScanner && !Entrolectura}
                    onScan={!Entrolectura ? handleQRScan : null}
                    onClose={closeQRScanner}
                />
            )}

        </>
    );
};

export default DespachoTab2;
